​@if (mainPage === true && !fromMyAppeals && !fromRMCDocUpload) {
<div class="p-2">
  <nh-alert type="success" [isOpen]="success">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../../assets/images/Icons/⚛️ icons-checkmark-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ "DOCUMENT_UPLOADED" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
  @if (response && ((rows && rows.length > 0) || (kbRows && kbRows.length > 0)
  || (appealRows && appealRows.length) || (!isPartnerApp && medicalAppealRows &&
  medicalAppealRows.length))) {
  <div>
    @if (!success) {
    <div>
      <h1 class="section-header">
        {{ "DOCUMENTS_WE_NEED" | globalTranslate }}
      </h1>
      <hr />
      <p [innerHTML]="'DOCUMENTS_WE_NEED_STATIC_TEXT21' | globalTranslate"></p>
      <div class="pb-3 popup">
        <a
          title="{{ 'Types of Proof' | globalTranslate }}"
          tabindex="0"
          (click)="showProofTypes()"
        >
          <span class="pe-2">{{ "Types of Proof" | globalTranslate }}</span>
          <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
        </a>
      </div>
      @if (isPartnerApp && !readTCC) {
      <p class="static-text">
        {{ "DOC_UPLOAD_FAQ" | globalTranslate
        }}<a
          tabindex="0"
          (click)="docUploadInfo()"
          class="learn_more pe-2"
          [attr.aria-label]="'Upload Documents Information' | globalTranslate"
          >{{ "here" | globalTranslate }}.</a
        >
      </p>
      } @if (isPartnerApp && readTCC) {
      <p class="static-text">
        {{ "DOC_UPLOAD_FAQ_VIEW_ONLY_TCC" | globalTranslate
        }}<a
          tabindex="0"
          (click)="docUploadInfo()"
          class="learn_more pe-2"
          [attr.aria-label]="'View Documents Information' | globalTranslate"
          >{{ "here" | globalTranslate }}.</a
        >
      </p>
      }
    </div>
    } @if (success) {
    <div>
      <p
        class="static-text"
        [innerHTML]="'DOCUMENTS_WE_NEED_STATIC_TEXT27' | globalTranslate"
      ></p>
      <p
        class="static-text"
        [innerHTML]="'DOCUMENTS_WE_NEED_STATIC_TEXT28' | globalTranslate"
      ></p>
      <p
        class="static-text"
        [innerHTML]="'DOCUMENTS_WE_NEED_STATIC_TEXT29' | globalTranslate"
      ></p>
      @if (rows && rows.length > 0) {
      <h2 class="section-header">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT17" | globalTranslate }}
      </h2>
      }
    </div>
    } @if (rows && rows.length > 0) {
    <hr />
    } @if (rows && rows.length) {
    <div class="d-none d-lg-block">
      <nh-alert type="warning" [isOpen]="vc136" class="preterm_banner">
        <div class="row">
          <div class="col-auto icon">
            <img
              src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
              alt=""
            />
          </div>
          <span class="visually-hidden">{{ "Alert" | globalTranslate }} </span>
          <div class="col message">
            <span
              >{{ "QFR_BANNER" | globalTranslate }}
              <strong
                >@if (!readTCC) {
                <a [routerLink]="['/user-profile/pre-term']"
                  >{{ "QFR" | globalTranslate }}.</a
                >
                }@if (readTCC) {
                <a [class.disabled]="readTCC">{{ "QFR" | globalTranslate }}.</a>
                }</strong
              ></span
            >
          </div>
        </div>
      </nh-alert>
      @if (!isMobileView) {
      <ngx-datatable
        class="bootstrap striped"
        #table
        [rows]="rows"
        [limit]="6"
        [columnMode]="'force'"
        [headerHeight]="'auto'"
        [footerHeight]="50"
        [rowHeight]="'auto'"
      >
        @for (col of columns; track col) {
        <ngx-datatable-column
          [name]="col.name | globalTranslate"
          [prop]="col.prop"
        >
          <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-value="value"
            let-rowIndex="rowIndex"
          >
            @if (col.name!=='Name') {
            <span>{{
              value === "N/A" ? value : (value | globalTranslate)
            }}</span>
            } @if (col.name==='Name') {
            <span>{{ value }} ({{ row.caseNum }})</span>
            }
          </ng-template>
        </ngx-datatable-column>
        }
        <ngx-datatable-column
          name="{{ 'Status' | globalTranslate }}"
          [width]="150"
        >
          <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex"
          >
            @if (row.submittedStatus === 'N') {
            <span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT3" | globalTranslate
            }}</span>
            } @if (row.submittedStatus === 'Y' && row.verfCd !== 'NGGA315') {
            <span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT4" | globalTranslate
            }}</span>
            } @if (row.submittedStatus === 'Y' && row.verfCd === 'NGGA315') {
            <span>{{ "Submitted" | globalTranslate }}</span>
            }
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="{{ 'Action' | globalTranslate }}"
          [width]="190"
        >
          <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex"
          >
            @if (row.verfCd !== 'VC190') { @if (row.submittedStatus === 'N') {
            <button
              [disabled]="readTCC"
              class="btn btn-sm btn-secondary"
              (click)="uploadProof(row)"
            >
              <span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT5" | globalTranslate
              }}</span>
            </button>
            }
            <div class="p-0 hover-red">
              @if (row.submittedStatus === 'Y') {
              <a
                [class.disabled]="readTCC"
                (click)="uploadProof(row)"
                class="btn p-0 hover-red text-start btn-link"
                tabindex="0"
                ><span>{{
                  "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
                }}</span></a
              >
              }
            </div>
            } @if (row.verfCd == 'VC190') {
            <span>N/A</span>
            }
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
      } @if (vc190) {
      <p>
        {{ "ECF_STATIC_TEXT_1" | globalTranslate }}
        <a href="https://perlss.tenncare.tn.gov/externalreferral"
          >https://perlss.tenncare.tn.gov/externalreferral</a
        >.
        {{ "ECF_STATIC_TEXT_2" | globalTranslate }}
      </p>
      }
    </div>
    }
    <div class="nh-table-mobile d-lg-none">
      @if (rows?.length) {
      <div>
        <nh-alert type="warning" [isOpen]="vc136" class="preterm_banner">
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                alt=""
              />
            </div>
            <span class="visually-hidden"
              >{{ "Alert" | globalTranslate }}
            </span>
            <div class="col message">
              <span
                >{{ "QFR_BANNER" | globalTranslate }}
                <strong
                  >@if (!readTCC) {
                  <a [routerLink]="['/user-profile/pre-term']"
                    >{{ "QFR" | globalTranslate }}.</a
                  >
                  }@if (readTCC) {
                  <a [class.disabled]="readTCC"
                    >{{ "QFR" | globalTranslate }}.</a
                  >
                  }</strong
                ></span
              >
            </div>
          </div>
        </nh-alert>
        @for (row of rows; track row) {
        <div class="table-row mb-3 pb-3">
          <div class="mobile-table-header">
            {{ columns[0].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ row.fullName }} ({{ row.caseNum }})
          </div>
          <br />
          <div class="mobile-table-header">
            {{ columns[1].name | globalTranslate }}
          </div>
          <hr />
          @if (this.translatedLang == 'en') {
          <div class="mobile-table-data">
            {{ row.proofType | globalTranslate }}
          </div>
          } @if (this.translatedLang !== 'en') {
          <div class="mobile-table-data">
            {{ row.proofTypeEs | globalTranslate }}
          </div>
          }
          <br />
          <div class="mobile-table-header">
            {{ columns[2].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{
              row.proofRequiredValue === "N/A"
                ? row.proofRequiredValue
                : (row.proofRequiredValue | globalTranslate)
            }}
          </div>
          <br />
          <div class="mobile-table-header">
            {{ columns[3].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">{{ row.verfDue }}</div>
          <br />
          <div class="mobile-table-header">
            {{ "Action" | globalTranslate }}
          </div>
          <hr />
          @if (row.verfCd !== 'VC190') { @if (row.submittedStatus === 'N') {
          <button
            [disabled]="readTCC"
            class="btn btn-sm btn-secondary action-button"
            (click)="uploadProof(row)"
          >
            {{ "DOCUMENTS_WE_NEED_STATIC_TEXT5" | globalTranslate }}
          </button>
          } @if (row.submittedStatus === 'Y') {
          <a
            [class.disabled]="readTCC"
            class="p-0 text-start hover-red btn-link"
            (click)="uploadProof(row)"
            tabindex="0"
            ><span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
            }}</span></a
          >
          } } @if (row.verfCd == 'VC190') {
          <span>N/A</span>
          }
          <br />
        </div>
        } @if (vc190) {
        <p>
          {{ "ECF_STATIC_TEXT_1" | globalTranslate }}
          <a href="https://perlss.tenncare.tn.gov/externalreferral"
            >https://perlss.tenncare.tn.gov/externalreferral</a
          >.
          {{ "ECF_STATIC_TEXT_2" | globalTranslate }}
        </p>
        }
      </div>
      }
      <!-- <p *ngIf="!rows?.length" class="mb-5">{{'NO_DATA_TO_DISPLAY' | globalTranslate }}</p> -->
    </div>
    <!-- Appeal rows section start for Desktop & Mobile -->
    @if (appealRows && appealRows.length > 0) {
    <div>
      <h2 class="section-header">
        @if(appealStatusTrackerSwitch){
        {{"APPEALS_STATUS_IN_01" | globalTranslate }}
        } @else{
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT18" | globalTranslate }}
        }
      </h2>
      <hr />
      <p [innerHTML]="'DOCUMENTS_WE_NEED_STATIC_TEXT24' | globalTranslate"></p>
      <div></div>
      <div class="d-none d-lg-block">
        <ngx-datatable
          class="bootstrap striped"
          #table
          [rows]="appealRows"
          [columnMode]="'standard'"
          [limit]="6"
          [headerHeight]="'auto'"
          [footerHeight]="50"
          [rowHeight]="'auto'"
        >
          <ngx-datatable-column
            [name]="'Name' | globalTranslate"
            prop="fullName"
            [width]="80"
          >
            <ng-template ngx-datatable-cell-template let-value="value">
              <span>{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [name]="'Appeal' | globalTranslate"
            prop="appealNum"
            [width]="84"
          >
            <ng-template ngx-datatable-cell-template let-value="value">
              <span>{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [name]="'Information Needed' | globalTranslate"
            prop="verfDesc"
            [width]="124"
          >
            <ng-template ngx-datatable-cell-template let-value="value">
              <span>{{ value | globalTranslate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [name]="'Date Filed' | globalTranslate"
            prop="appealFileDate"
            [width]="80"
          >
            <ng-template ngx-datatable-cell-template let-value="value">
              <span>{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [name]="'Last Updated' | globalTranslate"
            prop="lastUpdatedDateApl"
            [width]="95"
          >
            <ng-template ngx-datatable-cell-template let-value="value">
              <span>{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="{{ 'Status' | globalTranslate }}"
            [width]="125"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              @if (row.submittedStatus === 'N') {
              <span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT3" | globalTranslate
              }}</span>
              } @if (row.submittedStatus === 'Y') {
              <span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT4" | globalTranslate
              }}</span>
              }
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="{{ 'Action' | globalTranslate }}"
            [width]="200"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              @if (row.submittedStatus === 'N' && !row.uploadAppealProofVfd) {
              <button
                [disabled]="readTCC"
                class="btn btn-sm btn-secondary"
                (click)="uploadProof(row)"
              >
                <span>
                  {{
                    "DOCUMENTS_WE_NEED_STATIC_TEXT32" | globalTranslate
                  }}</span
                >
              </button>
              } @if (row.submittedStatus === 'N' && row.uploadAppealProofVfd) {
              <button
                [disabled]="readTCC"
                class="btn btn-sm btn-secondary"
                (click)="uploadProof(row)"
              >
                <span>
                  {{
                    "DOCUMENTS_WE_NEED_STATIC_TEXT22" | globalTranslate
                  }}</span
                >
              </button>
              }
              <div class="p-0 hover-red">
                @if (row.submittedStatus === 'Y') {
                <a
                  [class.disabled]="readTCC"
                  (click)="uploadProof(row)"
                  class="btn p-0 hover-red text-start btn-link"
                  tabindex="0"
                  ><span>{{
                    "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
                  }}</span></a
                >
                }
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
    }
    <div class="nh-table-mobile d-lg-none">
      @if (appealRows && appealRows.length > 0) { @for (row of appealRows; track
      row) {
      <div class="table-row mb-3 pb-3">
        <div class="mobile-table-header">
          {{ appealColumns[0].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.fullName }}</div>
        <br />
        <div class="mobile-table-header">{{ "Appeal" | globalTranslate }}</div>
        <hr />
        <div class="mobile-table-data">{{ row.appealNum }}</div>
        <br />
        <div class="mobile-table-header">
          {{ appealColumns[2].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">
          {{ row.verfDesc | globalTranslate }}
        </div>
        <br />
        <div class="mobile-table-header">
          {{ appealColumns[3].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.appealFileDate }}</div>
        <br />
        <div class="mobile-table-header">
          {{ appealColumns[4].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.lastUpdatedDateApl }}</div>
        <br />
        <div class="mobile-table-header">{{ "Action" | globalTranslate }}</div>
        <hr />
        <span>
          @if (row.submittedStatus === 'N' && !row.uploadAppealProofVfd) {
          <button
            [disabled]="readTCC"
            class="btn btn-sm btn-secondary action-button"
            (click)="uploadProof(row)"
          >
            <span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT32" | globalTranslate
            }}</span>
          </button>
          } @if (row.submittedStatus === 'N' && row.uploadAppealProofVfd) {
          <button
            [disabled]="readTCC"
            class="btn btn-sm btn-secondary action-button"
            (click)="uploadProof(row)"
          >
            <span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT22" | globalTranslate
            }}</span>
          </button>
          } @if (row.submittedStatus === 'Y') {
          <a
            [class.disabled]="readTCC"
            tabindex="0"
            class="p-0 text-start hover-red btn-link"
            (click)="uploadProof(row)"
            ><span>
              {{ "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate }}</span
            ></a
          >
          }
        </span>
        <br />
        <hr />
      </div>
      } }
      <!-- <p *ngIf="this.appealRows" class="mb-5">{{'NO_DATA_TO_DISPLAY' | globalTranslate }}</p> -->
    </div>
    <!-- Appeal rows section end for Desktop & Mobile -->
    <!-- Medical Appeal rows section start for Desktop & Mobile -->
    @if (!isPartnerApp && medicalAppealRows && medicalAppealRows.length > 0) {
    <div>
      <h2 class="section-header">{{ "MEDICAL_APPEALS" | globalTranslate }}</h2>
      <hr />
      <p [innerHTML]="'MEDICAL_APPEALS_SUBTEXT' | globalTranslate"></p>
      <div></div>
      <div class="d-none d-lg-block">
        <ngx-datatable
          class="bootstrap striped"
          #table
          [rows]="medicalAppealRows"
          [columnMode]="'standard'"
          [limit]="6"
          [headerHeight]="'auto'"
          [footerHeight]="50"
          [rowHeight]="'auto'"
        >
          @for (col of medicalAppealColumns; track col) {
          <ngx-datatable-column
            [name]="col.name | globalTranslate"
            [prop]="col.prop"
            [width]="col.width"
          >
          </ngx-datatable-column>
          }
          <ngx-datatable-column
            name="{{ 'Action' | globalTranslate }}"
            [width]="215"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              @if (row.submittedStatus === 'N') {
              <button
                [disabled]="readTCC"
                class="btn btn-sm btn-secondary"
                (click)="uploadProof(row)"
              >
                <span [ngClass]="{ button_text: translatedLang !== 'en' }">
                  {{ "UPLOAD_MEDICAL_APPEAL" | globalTranslate }}</span
                >
              </button>
              }
              <div class="p-0 hover-red">
                @if (row.submittedStatus === 'Y') {
                <a
                  [class.disabled]="readTCC"
                  (click)="uploadProof(row)"
                  class="btn p-0 hover-red text-start btn-link"
                  tabindex="0"
                  ><span>{{
                    "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
                  }}</span></a
                >
                }
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      <div class="nh-table-mobile d-lg-none">
        @if (medicalAppealRows && medicalAppealRows.length > 0) { @for (row of
        medicalAppealRows; track row) {
        <div class="table-row mb-3 pb-3">
          <div class="mobile-table-header">
            {{ medicalAppealColumns[0].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">{{ row.fullName }}</div>
          <br />
          <div class="mobile-table-header">
            {{ medicalAppealColumns[1].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">{{ row.issueId }}</div>
          <br />
          <div class="mobile-table-header">
            {{ medicalAppealColumns[2].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ row.verfDesc | globalTranslate }}
          </div>
          <br />
          <div class="mobile-table-header">
            {{ medicalAppealColumns[3].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">{{ row.appealDueDate }}</div>
          <br />
          <div class="mobile-table-header">
            {{ "Action" | globalTranslate }}
          </div>
          <hr />
          <span>
            @if (row.submittedStatus === 'N') {
            <button
              [disabled]="readTCC"
              class="btn btn-sm btn-secondary action-button"
              (click)="uploadProof(row)"
            >
              <span>{{ "UPLOAD_MEDICAL_APPEAL" | globalTranslate }}</span>
            </button>
            } @if (row.submittedStatus === 'Y') {
            <a
              [class.disabled]="readTCC"
              tabindex="0"
              class="p-0 text-start hover-red btn-link"
              (click)="uploadProof(row)"
              ><span>
                {{ "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate }}</span
              ></a
            >
            }
          </span>
          <br />
          <hr />
        </div>
        } }
        <!-- <p *ngIf="this.appealRows" class="mb-5">{{'NO_DATA_TO_DISPLAY' | globalTranslate }}</p> -->
      </div>
    </div>
    }
    <!-- Medical Appeal rows section end for Desktop & Mobile -->
    <!-- KB rows section end for Desktop & Mobile -->
    <!-- <div *ngIf="kbRows && kbRows.length > 0">
                                                                                      <h5 class="section-header">{{'DOCUMENTS_WE_NEED_STATIC_TEXT19' | globalTranslate }}</h5>
                                                                                      <hr>
                                                                                        <div class="d-none d-lg-block">
                                                                                          <ngx-datatable class='bootstrap striped' #table [rows]='kbRows' [columnMode]='"force"' [limit]="5"
                                                                                            [headerHeight]='"auto"' [footerHeight]='50' [rowHeight]='"auto"'>
                                                                                            <ngx-datatable-column [name]="col.name | globalTranslate" [prop]="col.prop" *ngFor="let col of kbColumns">
                                                                                            </ngx-datatable-column>
                                                                                            <ngx-datatable-column name="{{'Information Needed' | globalTranslate }}">
                                                                                              <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                                                                <span>{{'DOCUMENTS_WE_NEED_STATIC_TEXT20' | globalTranslate }}</span>
                                                                                              </ng-template>
                                                                                            </ngx-datatable-column>
                                                                                            <ngx-datatable-column name="{{'Action' | globalTranslate}}" [width]="200">
                                                                                              <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                                                                <button [disabled]="readTCC" *ngIf="row.submittedStatus === 'N'" class="btn btn-sm btn-secondary"
                                                                                                  (click)="uploadProof(row, true)"><span>{{'DOCUMENTS_WE_NEED_STATIC_TEXT5' | globalTranslate }}</span></button>
                                                                                                  <a [class.disabled]="readTCC" *ngIf="row.submittedStatus === 'Y'" (click)="uploadProof(row, true)"
                                                                                                    class="p-0 text-start hover-red btn-link"><span>{{'DOCUMENTS_WE_NEED_STATIC_TEXT6' | globalTranslate }}</span></a>
                                                                                                  </ng-template>
                                                                                                </ngx-datatable-column>
                                                                                              </ngx-datatable>
                                                                                            </div>
                                                                                            <div class="nh-table-mobile d-lg-none">
                                                                                              <div class="table-row mb-3 pb-3" *ngFor="let row of kbRows">
                                                                                                <div class="mobile-table-header">{{kbColumns[0].name | globalTranslate }}</div>
                                                                                                <hr>
                                                                                                  <div class="mobile-table-data">{{row.fullName}}</div>
                                                                                                  <br>
                                                                                                    <hr>
                                                                                                      <div class="mobile-table-header">{{kbColumns[1].name | globalTranslate }}</div>
                                                                                                      <hr>
                                                                                                        <div class="mobile-table-data">{{row.refId}}</div>
                                                                                                        <br>
                                                                                                          <div class="mobile-table-header">{{'Information Needed' | globalTranslate }}</div>
                                                                                                          <hr>
                                                                                                            <div class="mobile-table-data">{{'DOCUMENTS_WE_NEED_STATIC_TEXT20' | globalTranslate }}</div>
                                                                                                            <br>
                                                                                                              <div class="mobile-table-header">{{'Action' | globalTranslate}}</div>
                                                                                                              <hr>
                                                                                                                <span>
                                                                                                                  <button [disabled]="readTCC" *ngIf="row.submittedStatus === 'N'" class="btn btn-sm btn-secondary action-button" (click)="uploadProof(row, true)">
                                                                                                                    <span>{{'DOCUMENTS_WE_NEED_STATIC_TEXT5' | globalTranslate }}</span></button>
                                                                                                                    <a [class.disabled]="readTCC" *ngIf="row.submittedStatus === 'Y'" class="p-0 text-start hover-red btn-link" (click)="uploadProof(row, true)">
                                                                                                                      <span>{{'DOCUMENTS_WE_NEED_STATIC_TEXT6' | globalTranslate }}</span></a>
                                                                                                                    </span>
                                                                                                                    <br>
                                                                                                                      <hr>
                                                                                                                      </div>
                                                                                                                      <p *ngIf="!appealRows.length" class="mb-5">{{'NO_DATA_TO_DISPLAY' | globalTranslate }}</p>
                                                                                                                    </div>
                                                                                                                  </div> -->
    <!-- KB rows section end for Desktop & Mobile -->
    @if (householdRows && householdRows.length > 0) {
    <div>
      <h2 class="section-header">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT2" | globalTranslate }}
      </h2>
      <hr />
      <div class="d-none d-lg-block">
        <ngx-datatable
          class="bootstrap striped"
          #table
          [rows]="householdRows"
          [limit]="5"
          [columnMode]="'force'"
          [headerHeight]="'auto'"
          [footerHeight]="50"
          [rowHeight]="'auto'"
        >
          <ngx-datatable-column
            [name]="houseHoldColumns[0].name | globalTranslate"
            [prop]="houseHoldColumns[0].prop"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
            [name]="houseHoldColumns[1].name | globalTranslate"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.typeLabel | globalTranslate }}</span
              ><br />
              <span>{{ row.appNum }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            [name]="houseHoldColumns[2].name | globalTranslate"
            [prop]="houseHoldColumns[2].prop"
          >
          </ngx-datatable-column>
          <ngx-datatable-column
            name="{{ 'Status' | globalTranslate }}"
            [width]="160"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              @if (row.submittedStatus === 'N') {
              <span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT3" | globalTranslate
              }}</span>
              } @if (row.submittedStatus === 'Y') {
              <span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT4" | globalTranslate
              }}</span>
              }
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="{{ 'Action' | globalTranslate }}"
            [width]="245"
          >
            <ng-template
              ngx-datatable-cell-template
              let-row="row"
              let-rowIndex="rowIndex"
            >
              @if (row.submittedStatus === 'N') {
              <button
                [disabled]="readTCC"
                class="btn btn-sm btn-secondary"
                (click)="documentUploadB(row)"
              >
                <span>{{
                  "DOCUMENTS_WE_NEED_STATIC_TEXT5" | globalTranslate
                }}</span>
              </button>
              }
              <div class="p-0 hover-red">
                @if (row.submittedStatus === 'Y') {
                <a
                  [class.disabled]="readTCC"
                  (click)="documentUploadB(row)"
                  class="btn hover-red p-0 text-start btn-link"
                  tabindex="0"
                  ><span>{{
                    "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
                  }}</span></a
                >
                }
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      <div class="nh-table-mobile d-lg-none">
        @if (householdRows.length) { @for (row of householdRows; track row) {
        <div class="table-row mb-3 pb-3">
          <div class="mobile-table-header">
            {{ houseHoldColumns[0].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">{{ row.hohName }}</div>
          <br />
          <div class="mobile-table-header">
            {{ houseHoldColumns[1].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            {{ row.typeLabel | globalTranslate }}<br />{{ row.appNum }}
          </div>
          <br />
          <div class="mobile-table-header">
            {{ houseHoldColumns[2].name | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">{{ row.submissionDate }}</div>
          <br />
          <div class="mobile-table-header">
            {{ "Action" | globalTranslate }}
          </div>
          <hr />
          <span>
            @if (row.submittedStatus === 'N') {
            <button
              [disabled]="readTCC"
              class="btn btn-sm btn-secondary action-button"
              (click)="documentUploadB(row)"
            >
              <span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT5" | globalTranslate
              }}</span>
            </button>
            }
            <div class="p-0 hover-red">
              @if (row.submittedStatus === 'Y') {
              <a
                [class.disabled]="readTCC"
                (click)="documentUploadB(row)"
                class="btn p-0 text-start hover-red btn-link"
                tabindex="0"
                ><span>{{
                  "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
                }}</span></a
              >
              }
            </div>
          </span>
          <br />
          <hr />
        </div>
        } } @if (!householdRows.length) {
        <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
        }
      </div>
    </div>
    }
  </div>
  } @if (response && response.caseScenario === 'B' && !rows) {
  <div>
    @if (!success) {
    <div>
      <h1 class="section-header">
        {{ "DOCUMENTS_WE_NEED" | globalTranslate }}
      </h1>
      <hr />
      <p
        class="static-text"
        [innerHTML]="'DOCUMENTS_WE_NEED_SCENARIO_B_TEXT' | globalTranslate"
      ></p>
    </div>
    } @if (success) {
    <div>
      <p class="static-text">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT1" | globalTranslate }}
      </p>
      <p
        class="static-text"
        [innerHTML]="'DOCUMENTS_WE_NEED_SUCCESS_TEXT' | globalTranslate"
      ></p>
    </div>
    }
    <p
      class="static-text"
      [innerHTML]="'DOCUMENTS_WE_NEED_STATIC_TEXT26' | globalTranslate"
    ></p>
    <div style="margin: 0px 0px 32px 0px" class="ps-1 pt-1 hover-red">
      <a
        title="{{ 'Types of Proof' | globalTranslate }}"
        tabindex="0"
        (click)="showProofTypes()"
      >
        <span class="pe-2 popup">{{ "Types of Proof" | globalTranslate }}</span>
        <i
          aria-hidden="true"
          role="presentation"
          class="fa fa-external-link"
          aria-hidden="true"
        ></i>
      </a>
    </div>
    @if (isPartnerApp && !readTCC) {
    <p class="static-text">
      {{ "DOC_UPLOAD_FAQ" | globalTranslate
      }}<a
        tabindex="0"
        (click)="docUploadInfo()"
        class="learn_more pe-2"
        [attr.aria-label]="'Upload Documents Information' | globalTranslate"
        >{{ "here" | globalTranslate }}.</a
      >
    </p>
    } @if (isPartnerApp && readTCC) {
    <p class="static-text">
      {{ "DOC_UPLOAD_FAQ_VIEW_ONLY_TCC" | globalTranslate
      }}<a
        tabindex="0"
        (click)="docUploadInfo()"
        class="learn_more pe-2"
        [attr.aria-label]="'View Documents Information' | globalTranslate"
        >{{ "here" | globalTranslate }}.</a
      >
    </p>
    }
    <h2 class="section-header">
      {{ "DOCUMENTS_WE_NEED_STATIC_TEXT2" | globalTranslate }}
    </h2>
    <hr />
    <div class="d-none d-lg-block">
      <ngx-datatable
        class="bootstrap striped"
        #table
        [rows]="householdRows"
        limit="5"
        [columnMode]="'force'"
        [headerHeight]="'auto'"
        [footerHeight]="50"
        [rowHeight]="'auto'"
      >
        <ngx-datatable-column
          [name]="houseHoldColumns[0].name | globalTranslate"
          [prop]="houseHoldColumns[0].prop"
        >
        </ngx-datatable-column>
        <ngx-datatable-column
          [name]="houseHoldColumns[1].name | globalTranslate"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <span>{{ row.typeLabel | globalTranslate }}</span
            ><br />
            <span>{{ row.appNum }}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          [name]="houseHoldColumns[2].name | globalTranslate"
          [prop]="houseHoldColumns[2].prop"
        >
        </ngx-datatable-column>
        <ngx-datatable-column
          name="{{ 'Status' | globalTranslate }}"
          [width]="160"
        >
          <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex"
          >
            @if (row.submittedStatus === 'N') {
            <span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT3" | globalTranslate
            }}</span>
            } @if (row.submittedStatus === 'Y') {
            <span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT4" | globalTranslate
            }}</span>
            }
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="{{ 'Action' | globalTranslate }}"
          [width]="245"
        >
          <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex"
          >
            @if (row.submittedStatus === 'N') {
            <button
              [disabled]="readTCC"
              class="btn btn-sm btn-secondary"
              (click)="documentUploadB(row)"
            >
              <span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT5" | globalTranslate
              }}</span>
            </button>
            }
            <div class="p-0 hover-red">
              @if (row.submittedStatus === 'Y') {
              <a
                [class.disabled]="readTCC"
                (click)="documentUploadB(row)"
                class="btn p-0 hover-red text-start btn-link"
                tabindex="0"
                ><span>{{
                  "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
                }}</span></a
              >
              }
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
    <div class="nh-table-mobile d-lg-none">
      @if (householdRows.length) { @for (row of householdRows; track row) {
      <div class="table-row mb-3 pb-3">
        <div class="mobile-table-header">
          {{ houseHoldColumns[0].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.hohName }}</div>
        <br />
        <div class="mobile-table-header">
          {{ houseHoldColumns[1].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">
          {{ row.typeLabel | globalTranslate }}<br />{{ row.appNum }}
        </div>
        <br />
        <div class="mobile-table-header">
          {{ houseHoldColumns[2].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.submissionDate }}</div>
        <br />
        <div class="mobile-table-header">{{ "Status" | globalTranslate }}</div>
        <hr />
        <div class="mobile-table-data">
          @if (row.submittedStatus === 'N') {
          <span>{{ "DOCUMENTS_WE_NEED_STATIC_TEXT3" | globalTranslate }}</span>
          } @if (row.submittedStatus === 'Y') {
          <span>{{ "DOCUMENTS_WE_NEED_STATIC_TEXT4" | globalTranslate }}</span>
          }
        </div>
        <br />
        <div class="mobile-table-header">{{ "Action" | globalTranslate }}</div>
        <hr />
        <span>
          @if (row.submittedStatus === 'N') {
          <button
            [disabled]="readTCC"
            class="btn btn-sm btn-secondary w-100"
            (click)="documentUploadB(row)"
          >
            <span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT5" | globalTranslate
            }}</span>
          </button>
          }
          <div class="p-0 hover-red">
            @if (row.submittedStatus === 'Y') {
            <a
              [class.disabled]="readTCC"
              (click)="documentUploadB(row)"
              class="btn p-0 text-start hover-red btn-link"
              tabindex="0"
              ><span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
              }}</span></a
            >
            }
          </div>
        </span>
        <br />
        <hr />
      </div>
      } } @if (!householdRows.length) {
      <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
      }
    </div>
  </div>
  } @if (bccRows && bccRows.length > 0) {
  <div>
    <h2 class="section-header">
      {{ "DOCUMENTS_WE_NEED_BCC_STATIC1" | globalTranslate }}
    </h2>
    <hr />
    <p [innerHTML]="'DOCUMENTS_WE_NEED_BCC_STATIC3' | globalTranslate"></p>
    <div class="d-none d-lg-block">
      <ngx-datatable
        class="bootstrap striped"
        #table
        [rows]="bccRows"
        [columnMode]="'force'"
        [limit]="5"
        [headerHeight]="'auto'"
        [footerHeight]="50"
        [rowHeight]="'auto'"
      >
        @for (col of bccColumns; track col) {
        <ngx-datatable-column
          [name]="col.name | globalTranslate"
          [prop]="col.prop"
        >
        </ngx-datatable-column>
        }
        <ngx-datatable-column
          name="{{ 'Information Needed' | globalTranslate }}"
        >
          <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex"
          >
            <span>{{ "DOCUMENTS_WE_NEED_BCC_STATIC2" | globalTranslate }}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="{{ 'Due Date' | globalTranslate }}">
          <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex"
          >
            @if (row.verfDueDt) {
            <span>{{ row.verfDueDt }}</span>
            } @if (!row.verfDueDt) {
            <span>N/A</span>
            }
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column
          name="{{ 'Action' | globalTranslate }}"
          [width]="200"
        >
          <ng-template
            ngx-datatable-cell-template
            let-row="row"
            let-rowIndex="rowIndex"
          >
            @if (row.submittedStatus === 'N') {
            <button
              [disabled]="readTCC"
              class="btn btn-sm btn-secondary"
              (click)="documentUploadB(row)"
            >
              <span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT5" | globalTranslate
              }}</span>
            </button>
            }
            <div class="p-0 hover-red">
              @if (row.submittedStatus === 'Y') {
              <a
                [class.disabled]="readTCC"
                (click)="documentUploadB(row)"
                class="btn p-0 hover-red text-start btn-link"
                tabindex="0"
                ><span>{{
                  "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
                }}</span></a
              >
              }
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
    <div class="nh-table-mobile d-lg-none">
      @if (bccRows.length) { @for (row of bccRows; track row) {
      <div class="table-row mb-3 pb-3">
        <div class="mobile-table-header">
          {{ bccColumns[0].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.fullName }}</div>
        <br />
        <div class="mobile-table-header">
          {{ bccColumns[1].name | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">{{ row.caseNum }}</div>
        <br />
        <div class="mobile-table-header">
          {{ "Information Needed" | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-data">
          {{ "DOCUMENTS_WE_NEED_BCC_STATIC2" | globalTranslate }}
        </div>
        <hr />
        <div class="mobile-table-header">
          {{ "Due Date" | globalTranslate }}
        </div>
        <br />
        @if (row.verfDueDt) {
        <div class="mobile-table-data">{{ row.verfDueDt }}</div>
        } @if (!row.verfDueDt) {
        <div class="mobile-table-data">N/A</div>
        }
        <hr />
        <div class="mobile-table-header">{{ "Action" | globalTranslate }}</div>
        <hr />
        <span>
          @if (row.submittedStatus === 'N') {
          <button
            [disabled]="readTCC"
            class="btn btn-sm btn-secondary w-100"
            (click)="documentUploadB(row)"
          >
            <span>{{
              "DOCUMENTS_WE_NEED_STATIC_TEXT5" | globalTranslate
            }}</span>
          </button>
          }
          <div class="p-0 hover-red">
            @if (row.submittedStatus === 'Y') {
            <a
              [class.disabled]="readTCC"
              (click)="documentUploadB(row)"
              class="btn p-0 hover-red text-start btn-link"
              tabindex="0"
              ><span>{{
                "DOCUMENTS_WE_NEED_STATIC_TEXT6" | globalTranslate
              }}</span></a
            >
            }
          </div>
        </span>
        <br />
        <hr />
      </div>
      } } @if (!bccRows.length) {
      <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
      }
    </div>
  </div>
  } @if (!isPartnerApp) {
  <div>
    @if (response && response.caseScenario === 'C' && !response.bccTreatment &&
    !appealRows && !medicalAppealRows) {
    <div>
      <h2 class="section-header">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT15" | globalTranslate }}
      </h2>
      <hr />
      <p class="static-text">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT16" | globalTranslate }}
      </p>
    </div>
    }
  </div>
  } @if (!isPartnerApp && !linkMyCase) {
  <div>
    @if (response && response.caseScenario === null && !response.bccTreatment &&
    !appealRows && !medicalAppealRows && !householdRows) {
    <div>
      <h2 class="section-header">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT15" | globalTranslate }}
      </h2>
      <hr />
      <p class="static-text">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT16" | globalTranslate }}
      </p>
    </div>
    }
  </div>
  } @if (isPartnerApp) {
  <div>
    @if (response && response.caseScenario === 'C' && !response.bccTreatment &&
    !appealRows) {
    <div>
      <h2 class="section-header">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT15" | globalTranslate }}
      </h2>
      <hr />
      <p class="static-text">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT16" | globalTranslate }}
      </p>
      @if (isPartnerApp && !readTCC) {
      <p class="static-text">
        {{ "DOC_UPLOAD_FAQ" | globalTranslate
        }}<a
          tabindex="0"
          (click)="docUploadInfo()"
          class="learn_more pe-2"
          [attr.aria-label]="'Upload Documents Information' | globalTranslate"
          >{{ "here" | globalTranslate }}.</a
        >
      </p>
      } @if (isPartnerApp && readTCC) {
      <p class="static-text">
        {{ "DOC_UPLOAD_FAQ_VIEW_ONLY_TCC" | globalTranslate
        }}<a
          tabindex="0"
          (click)="docUploadInfo()"
          class="learn_more pe-2"
          [attr.aria-label]="'View Documents Information' | globalTranslate"
          >{{ "here" | globalTranslate }}.</a
        >
      </p>
      }
    </div>
    }
  </div>
  } @if (isPartnerApp && !linkMyCase) {
  <div>
    @if (response && response.caseScenario === null && !response.bccTreatment &&
    !appealRows && !householdRows) {
    <div>
      <h2 class="section-header">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT15" | globalTranslate }}
      </h2>
      <hr />
      <p class="static-text">
        {{ "DOCUMENTS_WE_NEED_STATIC_TEXT16" | globalTranslate }}
      </p>
      @if (isPartnerApp && !readTCC) {
      <p class="static-text">
        {{ "DOC_UPLOAD_FAQ" | globalTranslate
        }}<a
          tabindex="0"
          (click)="docUploadInfo()"
          class="learn_more pe-2"
          [attr.aria-label]="'Upload Documents Information' | globalTranslate"
          >{{ "here" | globalTranslate }}.</a
        >
      </p>
      } @if (isPartnerApp && readTCC) {
      <p class="static-text">
        {{ "DOC_UPLOAD_FAQ_VIEW_ONLY_TCC" | globalTranslate
        }}<a
          tabindex="0"
          (click)="docUploadInfo()"
          class="learn_more pe-2"
          [attr.aria-label]="'View Documents Information' | globalTranslate"
          >{{ "here" | globalTranslate }}.</a
        >
      </p>
      }
    </div>
    }
  </div>
  } @if (linkMyCase) {
  <div>
    <h2 class="section-header">
      {{ "DOCUMENTS_WE_NEED_STATIC_TEXT15" | globalTranslate }}
    </h2>
    <hr />
    <p class="static-text">
      {{ "DOCUMENTS_WE_NEED_STATIC_TEXT30" | globalTranslate }}
      @if (!readTCC && !isPresumptive && !isFullCoverageApp && !isPartnerApp) {
      <a [routerLink]="['/user-profile', 'case-link']"
        ><strong>{{
          "DOCUMENTS_WE_NEED_STATIC_TEXT31" | globalTranslate
        }}</strong></a
      >
      }@if (readTCC || isPresumptive || isFullCoverageApp || isPartnerApp) {
      <span>{{ "DOCUMENTS_WE_NEED_STATIC_TEXT31" | globalTranslate }}</span>
      }
    </p>
  </div>
  } @if (response && ((response.caseScenario !== 'C' && indiv &&
  response.caseScenario !== null) || response.bccTreatment === true)) {
  <div>
    <h2 class="section-header">
      {{ "DOCUMENTS_WE_NEED_STATIC_TEXT7" | globalTranslate }}
    </h2>
    <hr />
    <p class="static-text">
      {{ "DOCUMENTS_WE_NEED_STATIC_TEXT8" | globalTranslate }}
    </p>
    <p>
      <strong>{{ "DOCUMENTS_WE_NEED_STATIC_TEXT9" | globalTranslate }}</strong
      >{{ "DOCUMENTS_WE_NEED_STATIC_TEXT10" | globalTranslate }}
    </p>
    <p class="static-text">
      <strong>{{ "FAX" | globalTranslate }} </strong
      >{{ "DOCUMENTS_WE_NEED_STATIC_TEXT11" | globalTranslate }}
    </p>
    <p>{{ "DOCUMENTS_WE_NEED_STATIC_TEXT12" | globalTranslate }}</p>
    <div class="static-text">
      <strong>{{ "Mail: " | globalTranslate }}</strong
      >{{ "DOCUMENTS_WE_NEED_STATIC_TEXT13" | globalTranslate }}
    </div>
    <address>
      TennCare<br />
      P.O Box 305240<br />
      Nashville, TN 37230-5240<br />
    </address>
    <p class="static-text">
      {{ "DOCUMENTS_WE_NEED_STATIC_TEXT14" | globalTranslate }}
    </p>
  </div>
  }
</div>
} @if (caseA && clickedRow) {
<div>
  <nh-doc-upload
    [row]="clickedRow"
    [selectData]="referenceData"
    (docUploadSuccess)="documentUploaded($event)"
  >
  </nh-doc-upload>
</div>
} @if (caseB && appTrackingNum) {
<div>
  <nh-proof-upload
    [appTrackingNum]="appTrackingNum"
    [caseNumber]="caseNumber"
    [bccCase]="bccEnable"
    (docUploadSuccess)="documentUploaded($event)"
  ></nh-proof-upload>
</div>
} @if (bccEnable && !appTrackingNum) {
<div>
  <nh-proof-upload
    [appTrackingNum]="appTrackingNum"
    [caseNumber]="caseNumber"
    [bccCase]="bccEnable"
    (docUploadSuccess)="documentUploaded($event)"
  ></nh-proof-upload>
</div>
}
@if ((caseA && clickedRow) || (caseB && appTrackingNum) || (bccEnable &&
  !appTrackingNum)) {
  <div>
    <mat-accordion displayMode="" multi class="proof-types-accordion">
      <mat-expansion-panel class="proof-types-expansion-panel">
        <mat-expansion-panel-header
          class="proof-types-header"
          [attr.aria-label]="'TIPS_FOR_PHOTOS' | globalTranslate"
        >
          <mat-panel-title class="proof-types-panel-title">
            <div class="accordion-header-container">
              <div class="item-key">
                <strong class="proof-types-title">
                  {{ "TIPS_FOR_PHOTOS" | globalTranslate }}</strong
                >
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="proof-types-content">
          <div class="row small light-text">
            <div class="col-md-2 d-flex align-items-center justify-content-center">
              <img
                src="assets/images/camera.png"
                alt="{{ 'TIPS_FOR_PHOTOS' | globalTranslate }}"
                class="img-fluid camera-img"
              />
            </div>
            <div class="col-md-10">
              <p
                class="tips-paragraph"
                [innerHtml]="'TIPS_FOR_PHOTOS_TEXT_05' | globalTranslate"
              ></p>
              <ul class="tips-list">
                <li [innerHtml]="'TIPS_FOR_PHOTOS_TEXT_01' | globalTranslate"></li>
                <li [innerHtml]="'TIPS_FOR_PHOTOS_TEXT_02' | globalTranslate"></li>
                <li [innerHtml]="'TIPS_FOR_PHOTOS_TEXT_03' | globalTranslate"></li>
                <li [innerHtml]="'TIPS_FOR_PHOTOS_TEXT_04' | globalTranslate"></li>
              </ul>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
}
